import { render, staticRenderFns } from "./Celebration.vue?vue&type=template&id=45d2a268&"
import script from "./Celebration.vue?vue&type=script&lang=js&"
export * from "./Celebration.vue?vue&type=script&lang=js&"
import style0 from "./Celebration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports